export const LOAD_LOCAL_APP_USERS = 'management/LOAD_LOCAL_APP_USERS';
export const LOCAL_APPROLES_LOADED = 'management/LOCAL_APPROLES_LOADED';
export const SET_SELECTED_LOCAL_APP_USER = 'management/SET_SELECTED_LOCAL_APP_USER';
export const ADD_LOCAL_APP_USER = 'management/ADD_LOCAL_APP_USER';
export const LOCAL_APPENTITIES_LOADED = 'management/LOCAL_APPENTITIES_LOADED';
export const LOCAL_USER_ROLE_DETAILS_LOADED = 'management/LOCAL_USER_ROLE_DETAILS_LOADED';
export const SET_SELECTED_LOCAL_USER_ROLE_ACTIVE = 'management/SET_SELECTED_LOCAL_USER_ROLE_ACTIVE';
export const SET_SELECTED_LOCAL_USER_ROLE_GLOBAL = 'management/SET_SELECTED_LOCAL_USER_ROLE_GLOBAL';
export const SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_ACTIVE = 'management/SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_ACTIVE';
export const SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_INHERIT = 'management/SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_INHERIT';

